/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useMemo } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@mesh.ai/rabbit';
import { parseISO } from 'date-fns';

import { DateInputComp } from 'components/Views/components/DateInputComp';

import { convertDateToString6 } from 'constants/helper';

import { DatePicker } from 'uiToolkitV1/DatePicker';
import { DateRangeSelectDashed } from 'uiToolkitV1/DateRange/DateRangeSelectDashed';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const DOJ_OPTIONS = [
  {
    label: 'Before',
    value: 'BEFORE',
  },
  {
    label: 'Between',
    value: 'BETWEEN',
  },
  {
    label: 'After',
    value: 'AFTER',
  },
];

const DateRangeSelector = ({ employeeFilterDOJData, handleChange }) => {
  const { type, endDate, startDate } = employeeFilterDOJData?.[0] ?? {};
  const startDateObj = useMemo(() => (startDate ? new Date(parseISO(startDate)) : null), [startDate]);
  const endDateObj = useMemo(() => (endDate ? new Date(parseISO(endDate)) : null), [endDate]);

  const onDateRangeChange = useCallback(
    (range) => {
      handleChange([
        {
          type,
          startDate: convertDateToString6(range.startDate),
          endDate: convertDateToString6(range.endDate),
        },
      ]);
    },
    [handleChange, type]
  );

  return (
    <DateRangeSelectDashed
      onSelect={onDateRangeChange}
      placeholderText="Select Range"
      initialDateRange={{ startDate: startDateObj, endDate: endDateObj }}
      // onClear={onDateRangeClear}
      // minDate={minDate}
      // maxDate={maxDate}
      displayCancelButton={false}
      displayClearButton={false}
      width="80%"
      isPortalContent={false}
    />
  );
};

const SingleDateSelector = ({ employeeFilterDOJData, handleChange }) => {
  const { type: currType, endDate, startDate } = employeeFilterDOJData?.[0] ?? {};
  const type = currType || DOJ_OPTIONS[0].value;

  const selectedDate = type === 'BEFORE' ? endDate : startDate;

  const onChange = (value) => {
    handleChange([
      {
        type,
        endDate: type === 'BEFORE' ? convertDateToString6(value) : null,
        startDate: type === 'AFTER' ? convertDateToString6(value) : null,
      },
    ]);
  };

  const selectedDateObj = useMemo(() => (selectedDate ? parseISO(selectedDate) : null), [selectedDate]);
  return (
    <DatePicker
      CustomInput={DateInputComp}
      selectedDate={selectedDateObj}
      onChange={(val) => onChange(val)}
      customInputProps={{ width: '160px' }}
      // minDate={minEndDate}
      // maxDate={maxEndDate}
      // popperPlacement="bottom"
    />
  );
};

export const DOJComp = ({ employeeFilterDOJData, handleChange }) => {
  const type = employeeFilterDOJData?.[0]?.type ?? DOJ_OPTIONS[0].value;

  const onChange = (value) => {
    handleChange([
      {
        type: value,
        startDate: null,
        endDate: null,
      },
    ]);
  };

  return (
    <Box p="2">
      <Flex alignItems="center" gap={2}>
        <TextBodyMedium>Include employees hired </TextBodyMedium>

        <Box w="110px">
          <Select value={type} onValueChange={onChange}>
            <SelectTrigger className="w-full">
              <SelectValue />
            </SelectTrigger>
            <SelectContent style={{ zIndex: 1510 }}>
              {DOJ_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Box>
      </Flex>

      {type === 'BETWEEN' ? (
        <DateRangeSelector employeeFilterDOJData={employeeFilterDOJData} handleChange={handleChange} />
      ) : (
        <SingleDateSelector employeeFilterDOJData={employeeFilterDOJData} handleChange={handleChange} />
      )}
    </Box>
  );
};
